export const TRADE_OPTIONS = [
  { value: "general", label: "General / multiple trades" },
  { value: "plumbing", label: "Plumbing" },
  { value: "building", label: "Building & carpentry" },
  { value: "electrical", label: "Electrical" },
  { value: "hvac", label: "Heating & air conditioning" },
  { value: "landscaping", label: "Landscaping" },
  { value: "painting", label: "Painting & decorating" },
  { value: "security", label: "Security & communications" },
];
